
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {AccountService} from "../../services";
import {environment} from "../../../../environments/environment";
import {File} from "../../models/file";
import {FileList} from "../../models/fileList";



@Injectable({ providedIn: 'root' })
export class InternalFileService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAll(offset: number, limit: number) {
        let filtersString = '';

        return this.http.get<FileList>(`${environment.apiEndpoint}/v1/files?offset=`+offset+`&limit=`+limit + filtersString, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getById(id: string) {
        return this.http.get<File>(`${environment.apiEndpoint}/v1/files/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    uploadFile(formData) {
        return this.http.post(`${environment.apiEndpoint}/v1/files/upload`, formData, {
            headers: new HttpHeaders({
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + this.accountService.userValue.token,
                }
            ),
            reportProgress: true,
            observe: 'events'
        });
    }

    downloadFile(id: string) {
        return this.http.get<string>(`${environment.apiEndpoint}/v1/files/download/${id}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    delete(id: string) {
        return this.http.delete(`${environment.apiEndpoint}/v1/files/` + id, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        })
            .pipe(map(x => {
                return x;
            }));
    }
}
